import React from 'react';

const PointContainer = ({ point = 0, size = 24 }) => {
  // 포인트를 0-100 범위로 제한
  const normalizedPoint = Math.max(0, Math.min(100, point));
  
  // 점수 범위에 따른 이미지 선택
  const getPointImage = (point) => {
    if (point === 100) return '/images/bapfriend_point06.png';
    if (point >= 80) return '/images/bapfriend_point05.png';
    if (point >= 60) return '/images/bapfriend_point04.png';
    if (point >= 40) return '/images/bapfriend_point03.png';
    if (point >= 20) return '/images/bapfriend_point02.png';
    return '/images/bapfriend_point01.png';
  };

  const pointImage = getPointImage(normalizedPoint);

  return (
    <div 
      className="flex items-center justify-center"
      style={{
        width: size,
        height: size,
      }}
      title={`포인트: ${normalizedPoint}`}
    >
      <img 
        src={pointImage} 
        alt={`포인트 ${normalizedPoint}`}
        className="w-3/4 h-3/4 object-contain"
      />
    </div>
  );
};

export default PointContainer; 